// Testi verificati sulla dashboard il 2026-10-16 (vedi spec guide richieste, note spese e report).
export default {
  slug: 'note-spese',
  module: 'expenses',
  title: 'Le note spese',
  tile: 'Controlla e approva le spese, raggruppale, trasmettile allo studio.',
  minutes: 4,
  publishedAt: '2026-10-26T12:00:00.000Z',
  moduleLabel: 'Apri le note spese',
  modulePath: 'expenseReports',
  brief: {
    purpose: 'Controllare e approvare le spese dei dipendenti e trasmetterle allo studio per il rimborso.',
    who: 'Chi in azienda approva le note spese.',
    when: 'Quando arrivano nuove note e prima di chiudere il mese.',
  },
  steps: [
    {
      title: 'Le schede',
      text: '«Da approvare» è la vista di partenza; poi Approvate, Inviate allo studio, Rimborsate, Rifiutate e, se la tua azienda la usa, Da correggere.',
      screen: 'note-spese-1',
      notes: ['«Da approvare»: le spese che aspettano una tua risposta', 'Le altre schede seguono la nota fino al rimborso'],
    },
    {
      title: 'Controlla e approva',
      text: 'Clicca una riga: vedi importo, voce di spesa e allegati. Premi «Approva» o «Rifiuta»; se la tua azienda lo usa, con «Respingi» rimandi la nota al dipendente con una motivazione.',
      screen: 'note-spese-2',
      notes: ['Gli allegati: ricevute e scontrini', '«Respingi», se la tua azienda lo usa, rimanda la nota al dipendente per correggerla'],
      tip: 'Con «Approva selezionate» approvi più note insieme.',
    },
    {
      title: 'Raggruppa le spese',
      text: 'Seleziona più spese dello stesso viaggio e premi «Raggruppa spese»: diventano un gruppo con lo stesso riferimento.',
      screen: 'note-spese-3',
      notes: ['Seleziona almeno due spese dello stesso viaggio'],
    },
    {
      title: 'Trasmetti allo studio',
      text: 'Nella scheda «Approvate» seleziona le note e premi «Trasmetti allo studio», poi «Conferma e invia».',
      screen: 'note-spese-4',
      notes: ['Nella scheda «Approvate» seleziona le note da inviare', '«Trasmetti allo studio», poi «Conferma e invia»'],
    },
  ],
  faq: [
    {
      question: 'Che differenza c’è tra «Rifiuta» e «Respingi»?',
      answer: 'Con «Rifiuta» la nota non viene rimborsata. Con «Respingi», se la tua azienda lo usa, torna al dipendente, che può correggerla e inviarla di nuovo.',
    },
    {
      question: 'Cosa significa «Da inserire» nel rimborso chilometrico?',
      answer: 'La spesa ha dei chilometri ma manca l’importo del rimborso: aprila e inseriscilo prima di approvarla.',
    },
  ],
};
